import { API_BASE_URL } from '@src/globals';
import { GET } from '@api/apiHandler';
import { AGENT_FLOW_GENERATE_TOKEN } from '@api/routes';

export const createAgentFlowToken = async () => {
    return GET(`${API_BASE_URL}${AGENT_FLOW_GENERATE_TOKEN}`);
};

